import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import Modal from '@/assets/common/Modal/Modal.vue';
import { toCamel } from 'snake-camel';
import { Stock } from '@/types/Component';
import moment from 'moment';

type StockPostModel = {
    id: string | null,
    purchase_date: string,
    inner_capacity: number,
    quantity: number,
    amount: number,
    update_type?: 'ADD' | 'UPDATE' | 'DELETE'
}

type PurchaseHistoryPostModel = {
    stocks: StockPostModel[]
}

@Component({
    components: {
        Modal
    }
})
export default class PurchaseHistoryModal extends Vue {
    @Prop()
    private value!: boolean

    @Prop()
    private warehouseId!: string
    @Prop()
    private itemType!: 'chemicals' | 'fertilizers'
    @Prop()
    private itemId!: string
    @Prop()
    private unitName!: string
    @Prop()
    private itemName!: string

    private editStocks: Stock[] = []
    private deleteStocks: Stock[] = []

    private modalTitle = '購入履歴'

    get showPurchaseHistoryModal(): boolean {
        return this.value
    }
    set showPurchaseHistoryModal(b: boolean) {
        b
    }

    get oneStock(): boolean {
        return this.editStocks.length === 1
    }

    get baseUrl(): string {
        return `/admin/warehouses/${this.warehouseId}/${this.itemType}/${this.itemId}/stocks`
    }

    init(): void {
        this.editStocks = []
        this.deleteStocks = []
        if (this.value) {
            this.$apiClient.doRequest('get', this.baseUrl)
                .then(res => {
                    this.editStocks = res.stocks.map((s: any) => toCamel(s)) as Stock[]
                    this.modalTitle = '購入履歴'+'('+this.itemName+')'
                })
        }
    }

    @Watch('value')
    whenOpen(): void {
        this.init()
    }

    addStock(): void {
        const today = new Date()
        this.editStocks.unshift({
            id: null,
            purchaseDate: moment(today).format('yyyy-MM-DD'),
            innerCapacity: 0,
            quantity: 0,
            amount: 0,
            remainingQuantity: 0,
            isEditable: true,
            updateType: 'ADD'
        })
    }

    updateStock(index: number): void {
        if (this.editStocks[index].id) {
            this.editStocks[index] = {
                ...this.editStocks[index],
                updateType: 'UPDATE'
            }
        }
    }

    deleteStock(index: number): void {
        if (this.editStocks[index].id) {
            this.deleteStocks.push({
                ...this.editStocks[index],
                updateType: 'DELETE'
            })
        }
        this.editStocks.splice(index, 1)
    }

    commit(): void {
        const errflag = {
            innerCapacityNegative: false,
            quantityNegative: false,
            quantityNotInteger: false,
            amountNegative: false,
            amountNotInteger: false
        }
        this.editStocks.forEach(s => {
            if(s.innerCapacity.toString() !== '') {
                if(s.innerCapacity < 0) {
                    errflag.innerCapacityNegative = true
                }
            }
            else {
                s.innerCapacity = 0
            }
            if(s.quantity.toString() !== '') {
                if(s.quantity < 0) {
                    errflag.quantityNegative = true
                }
                else if(!(/^\d+$/.test(s.quantity.toString()))) {
                    errflag.quantityNotInteger = true
                }
            }
            else {
                s.quantity = 0
            }
            if(s.amount.toString() !== '') {
                if(s.amount < 0) {
                    errflag.amountNegative = true
                }
                else if(!(/^\d+$/.test(s.amount.toString()))) {
                    errflag.amountNotInteger = true
                }
            }
            else {
                s.amount = 0
            }
        })
        
        const errmsg: string[] = []
        if(errflag.innerCapacityNegative) {
            errmsg.push("内容量に0以上を入力してください")
        }
        if(errflag.quantityNegative) {
            errmsg.push("個数に0以上を入力してください")
        }
        if(errflag.quantityNotInteger) {
            errmsg.push("個数に整数を入力してください")
        }
        if(errflag.amountNegative) {
            errmsg.push("金額に0以上を入力してください")
        }
        if(errflag.amountNotInteger) {
            errmsg.push("金額に整数を入力してください")
        }
        if(errmsg.length > 0) {
            window.alert(errmsg.join('\n'))
            return
        }


        const stocks = this.editStocks.concat(this.deleteStocks)
        const data: PurchaseHistoryPostModel = {
            stocks: stocks
                .filter(s => s.updateType !== undefined)
                .map(s => (
                    {
                        id: s.id,
                        purchase_date: s.purchaseDate.toString(),
                        inner_capacity: s.innerCapacity,
                        quantity: s.quantity,
                        amount: s.amount,
                        update_type: s.updateType
                    }
                ))
        }
        this.$apiClient.doRequest('put', this.baseUrl, data)
            .then(() => {
                this.save()
                this.$toasted.success('保存しました。')
            })
            .catch(() => {
                this.$toasted.error('保存に失敗しました。')
            })
    }
    @Emit('save')
    save(): void {
        this.editStocks = []
        this.deleteStocks = []
        return
    }
    @Emit('cancel')
    cancel(): void {
        const result = window.confirm('変更内容を破棄します。よろしいですか。')
        if (!result) {
            return
        }
        this.editStocks = []
        this.deleteStocks = []
    }
}
